import { FilterPageOrderApi } from '@core/services/http-params/model/api-http-params.model';
import { InvoiceClaimLevel, InvoiceStatusCode } from '@core/domain/model/invoices/my-invoices-listing.model';

export type MyInvoicesListingApi = {
  numeroFactura: string;
  nombreRazonSocial: string;
  codigoRazonSocial: string;
  cif: string;
  nombreInstalacion: string;
  codigoInstalacion: string;
  cups: string;
  fechaEmision: string;
  fechaInicioSuministro: string;
  fechaFinSuministro: string;
  grupoFacturacion: string;
  tipo: string;
  consumo: number;
  importe: number;
  estadoFactura: string;
  estadoFacturaCodigo: InvoiceStatusCode;
  idDCTMFactura: string;
  nivelReclamacion: string;
  codigoNivelReclamacion: InvoiceClaimLevel;
  parado: boolean;
};

export type MyInvoicesListingFilterApi = FilterPageOrderApi & {
  filterCodSociedades?: Array<string>;
  filterCodInstalaciones?: Array<string>;
  filterNumFactura?: string;
  filterFechaIniEmision?: string;
  filterFechaFinEmision?: string;
  filterEstadoFactura?: MyInvoicesListingStatusFilterApi;
};

export enum MyInvoicesListingStatusFilterApi {
  PAGADO = 'PAGADO',
  PENDIENTE = 'PENDIENTE',
}
